module.exports = __webpack_public_path__ + "img/Unidad15-5.907eb13a.png";